// extracted by mini-css-extract-plugin
export default {"wrapper":"no-content__wrapper--Ies2n"};